import { createAsyncThunk } from "@reduxjs/toolkit";
import { UserService } from "../../services/UsersService";

export const getUserPools = createAsyncThunk("pool/getUserPools", async () => {
  const response = await UserService.getUserPools();
  const data = await response.data;
  return data;
});
